import React, { useState } from "react";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import RGL, { WidthProvider } from "react-grid-layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimes, faUndo } from "@fortawesome/free-solid-svg-icons";

const widgets = [
  {
    value: "./ActiveUsersWidget.jsx",
    label: "Active Users",
  },
  // {
  //   value: "./ApiDataCollectionsWidget.jsx",
  //   label: "Api Data Collections",
  // },
  // {
  //   value: "./ApiProfilesWidget.jsx",
  //   label: "Api Profiles",
  // },
  {
    value: "./AssetsWidget.jsx",
    label: "Assets",
  },
  // {
  //   value: "./BoomcastWidget.jsx",
  //   label: "Boomcast",
  // },
  // {
  //   value: "./BoomlogicWidget.jsx",
  //   label: "Boomlogic",
  // },
  {
    value: "./BroadcastsWidget.jsx",
    label: "Broadcasts",
  },
  // {
  //   value: "./ComponentsWidget.jsx",
  //   label: "Components",
  // },
  // {
  //   value: "./ContactsWidget.jsx",
  //   label: "Contacts",
  // },
  // {
  //   value: "./DocumentLibraryWidget.jsx",
  //   label: "Document Library",
  // },
  // {
  //   value: "./FeaturesWidget.jsx",
  //   label: "Features",
  // },
  // {
  //   value: "./FinancialWidget.jsx",
  //   label: "Financial",
  // },
  // {
  //   value: "./EventsWidget.jsx",
  //   label: "Events",
  // },
  // {
  //   value: "./MonitoringWidget.jsx",
  //   label: "Monitoring",
  // },
  // {
  //   value: "./GroupsWidget.jsx",
  //   label: "Groups",
  // },
  // {
  //   value: "./ImportedContactsWidget.jsx",
  //   label: "Imported Contacts",
  // },
  // {
  //   value: "./LogicLibraryWidget.jsx",
  //   label: "Logic Library",
  // },
  {
    value: "./ContactsAndAssetsMapWidget.jsx",
    label: "Contacts and Assets Map",
  },
  // {
  //   value: "./LiveEventsMapWidget.jsx",
  //   label: "Live Events Map",
  // },
  {
    value: "./MapWeatherForecastWidget.jsx",
    label: "Weather Forecast Map",
  },
  // {
  //   value: "./AlertMapWidget.jsx",
  //   label: "AlertMap",
  // },
  {
    value: "./MessagesProcessedWidget.jsx",
    label: "Messages Processed",
  },
  {
    value: "./MessagesWidget.jsx",
    label: "Messages",
  },
  {
    value: "./MessagingWidget.jsx",
    label: "Messaging",
  },
  {
    value: "./SystemUsageWidget.jsx",
    label: "System Usage",
  },
  // {
  //   value: "./CriticalEventWidget.jsx",
  //   label: "Critical Event",
  // },

  // {
  //   value: "./WorkflowsWidget.jsx",
  //   label: "Workflows",
  // },
];
const Widgets = require.context("../Common/widgets", true, /\.jsx$/);
const ReactGridLayout = WidthProvider(RGL);

export default function WidgetContainer({
  defaultLayout = [],
  lsField = "widgetLayout",
}) {
  const [layout, setLayout] = useState(
    JSON.parse(localStorage.getItem(lsField + "new")) || defaultLayout
  );
  const visibleLayout = layout.filter((l) => widgets.find((w) => l.i === w.value));
  const availableWidgets = widgets.filter(
    (w) => !layout.find((l) => l.i === w.value)
  );

  return (
    <div>
      <div className="d-flex justify-content-end">
        <DropdownButton
          id="add-widget-button"
          title={
            <span className="text-purple">
              Add <FontAwesomeIcon icon={faPlus} className="text-purple" />
            </span>
          }
          variant=""
          align={"end"}
        >
          {availableWidgets.length === 0 ? (
            <Dropdown.ItemText className="text-muted text-nowrap">
              No widgets available to add.
            </Dropdown.ItemText>
          ) : (
            availableWidgets.map((w, index) => (
              <Dropdown.Item
                key={index}
                as="button"
                className="btn"
                onClick={(e) => {
                  setLayout((prev) =>
                    prev.concat({
                      i: w.value,
                      x:
                        ((prev[prev.length - 1]?.x ?? 0) +
                          (prev[prev.length - 1]?.w ?? 0)) %
                        20,
                      y: Infinity,
                      w: 5,
                      h: 10,
                    })
                  );
                }}
              >
                {w.label}
              </Dropdown.Item>
            ))
          )}
        </DropdownButton>
        <button
          type="button"
          onClick={() => setLayout(defaultLayout)}
          className="btn"
          title="Reset layout"
        >
          <FontAwesomeIcon icon={faUndo} className="text-purple" />
        </button>
      </div>
      <ReactGridLayout
        cols={20}
        rowHeight={25}
        allowOverlap={false}
        autoSize
        useCSSTransforms
        layout={layout}
        draggableHandle=".widget-header"
        onLayoutChange={(l) => {
          setLayout(l);
          localStorage.setItem(lsField + "new", JSON.stringify(l));
        }}
        style={{ margin: "0 -10px" }}
      >
        {visibleLayout.length === 0 ? (
          <div
            key="empty-widgets"
            data-grid={{ x: 0, y: 0, w: 20, h: 3, static: true }}
            className="bg-white text-secondary d-flex align-items-center justify-content-center rounded-3"
          >
            No widgets to show. Click Add to add one.
          </div>
        ) : (
          visibleLayout.map((w) => {
            const W = Widgets(w.i).default;
            return (
              <div
                key={w.i}
                className="card-gradient rounded-3 overflow-hidden text-white"
                style={{
                  backgroundSize: "100vw",
                  backgroundPositionX: `${(w.x / 20) * 100}%`,
                }}
              >
                <button
                  type="button"
                  className="btn position-absolute top-0 end-0 z-1"
                  onClick={() => {
                    setLayout((prev) => prev.filter((l) => l.i !== w.i));
                  }}
                >
                  <FontAwesomeIcon className="text-white" icon={faTimes} />
                </button>
                <W />
              </div>
            );
          })
        )}
      </ReactGridLayout>
    </div>
  );
}
